export default __webpack_public_path__ + "static/media/carrier-global_results.png";